export enum EmissionHistoryAssetDirection {
  Issue = 'issue',
  Burn = 'burn',
}

export enum EmissionHistoryAssetStatus {
  Created = 'created',
  Confirmed = 'confirmed',
  Canceled = 'canceled',
}

export enum EEmissionHistoryTableColumns {
  TransactionId = 'guid',
  CounterpartyName = 'counterparty_name',
  Created = 'created_at',
  Initiator = 'created_by',
  Approved = 'updated_by',
  Amount = 'requested_amount',
  ReserveBalance = 'reserve_balance_amount',
  Type = 'direction',
  Status = 'status',
}

export enum EAction {
  Approve = 'Approve',
  Cancel = 'Cancel',
}
